import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'

function handleAddonClasses({
  plans,
  hasDentalActive,
  dentalPlanId,
  visionPlanId,
  latitudeId,
  supplementalId,
  externalPlans = [],
  externalPlanSelected = ''
}) {
  
  const hasDental = Boolean(plans[dentalPlanId]) && !hasDentalActive
  const hasSupplemental = Boolean(plans[supplementalId])
  const hasLatitude = Boolean(plans[latitudeId])
  const hasVision = Boolean(plans[visionPlanId])
  const externalPlan = externalPlans.find((externalPlan: any) => externalPlan.id === externalPlanSelected)
  const hasExternalPlan = Boolean(externalPlan)
  const loading = document.body.classList.contains('show-loading')
  
  if (!loading) {
    toggleClass('body', 'has-dental', hasDental)
    toggleClass('body', 'has-vision', hasVision)
    toggleClass('body', 'has-latitude', hasLatitude)
    toggleClass('body', 'has-supplemental', hasSupplemental)
    toggleClass('body', 'has-flex-benefits', hasExternalPlan)
  }

  if (hasLatitude) {
    textContent('.js-latitude-title', plans[latitudeId].planName)
  }

  if (hasExternalPlan) {
    textContent('.js-flex-benefits-title', externalPlan?.name)
  }
}

export default handleAddonClasses
